import { useEffect } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { DiscoverabilityPopupDismissed } from 'FileManagerCore/Constants';
import { updatePortalMeta } from 'FileManagerCore/actions/PortalMeta';
import PortalMetaCategoryIds from 'FileManagerCore/enums/PortalMetaCategoryIds';
import { getShouldShowVideo2EnabledByDefaultAlert } from 'FileManagerCore/selectors/UserSettings';
import UIAlert from 'UIComponents/alert/UIAlert';
import usageTracker from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const getI18nKey = suffix => `FileManagerCore.videoOptIn.optedInByDefaultAlert.${suffix}`;
const Video2EnabledByDefault = ({
  shouldShowAlert,
  dispatch
}) => {
  useEffect(() => {
    if (shouldShowAlert) {
      usageTracker.track('fileManagerVideoOptIn', {
        action: 'show enabled by default alert'
      });
    }
  }, [shouldShowAlert]);
  const handleDismiss = () => {
    usageTracker.track('fileManagerVideoOptIn', {
      action: 'dismiss enabled by default alert'
    });
    dispatch(updatePortalMeta(PortalMetaCategoryIds.VIDEO2_OPTIN_NOTICE, DiscoverabilityPopupDismissed));
  };
  if (!shouldShowAlert) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "success",
    className: "p-y-4",
    closeable: true,
    onClose: handleDismiss,
    "data-test-id": "video2-enabled-by-default-alert",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: getI18nKey('title')
    }),
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: getI18nKey('message')
    })
  });
};
const mapStateToProps = state => ({
  shouldShowAlert: getShouldShowVideo2EnabledByDefaultAlert(state)
});
export default connect(mapStateToProps)(Video2EnabledByDefault);